import * as clack from '@clack/prompts'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveConfig } from './resolve-config.js'

export async function resolveConfigOrExit(cwd?: string): Promise<ResolvedBetterstartConfig> {
  try {
    return await resolveConfig(cwd)
  } catch (error) {
    clack.log.error(
      `Error loading config: ${error instanceof Error ? error.message : String(error)}`
    )
    process.exit(1)
  }
}
